<template>
    <v-row class="flex-wrap"
           justify="center"
           dir="ltr"
    >
        <v-col :key="'box_'+idx"
               @click="setActiveInput(idx)"
               cols="auto"
               v-for="(item, idx) in count"
        >
            <v-text-field
                :key="'input_'+idx"
                :name="'OTP_'+idx"
                :ref="'input_'+idx"
                :style="currentInput===idx ? 'border: 1px solid '+activeColor : ''"
                @input.native.stop="nextInput($event)"
                @keypress="isNumber($event)"
                autocomplete="off"
                class="remove-blinking otp-center-text"
                hide-details
                light
                solo
                style="max-width: 50px;"
                tabindex="-1"
                v-model="code[idx]"
                v-on:keyup.backspace="idx < 1 ? null : backspacePressed($event)"
                v-on:keyup.enter="enterPressed()"
                v-on:keyup.left="idx < 1 ? null : previousInput()"
                v-on:keyup.right="idx >= count ? null : nextInput()"
                v-on:keyup.tab="null"
            ></v-text-field>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "OtpInputs",
        props: {
            count: {
                type: Number,
                default: 6
            },
            submitWhenComplete: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                currentInput: 0,
                code: [],
                activeColor: this.$vuetify.theme.defaults.light.primary,
                errorColor: this.$vuetify.theme.defaults.light.error,
                deleted: false,
            }
        },
        watch: {
            code(val) {
                this.$emit('input', val.join(''));
                if (this.submitWhenComplete) {
                    const isValid = this.validateOTP();
                    if (isValid) this.$emit('submit', val.join(''));
                }
            }
        },
        methods: {
            setActiveInput(input) {
                if (input == null || input === this.currentInput) return;
                if (input < 0 || input >= this.count) return;
                this.$nextTick(() => {
                    this.currentInput = input;
                    this.$refs['input_' + input][0].focus();
                });
            },
            nextInput(evt) {
                this.$emit('clear');
                evt = evt != null ? evt : window.event;
                if (evt == null || evt.inputType === 'deleteContentBackward' || evt.inputType === 'deleteContentForward') {
                    evt.preventDefault();
                    this.deleted = true;
                    return false;
                }
                const input = this.currentInput + 1;
                this.setActiveInput(input);
            },
            previousInput() {
                const input = this.currentInput - 1;
                this.setActiveInput(input);
            },
            isNumber(evt) {
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46 || charCode === 13) {
                    evt.preventDefault();
                } else if (evt.key < 0 || evt.key > 9) {
                    evt.preventDefault();
                } else {
                    this.$nextTick(() => {
                        this.$set(this.code, this.currentInput, null);
                        return true;
                    });
                }
            },
            backspacePressed() {
                this.$emit('clear');
                if (this.deleted) {
                    this.deleted = false;
                } else {
                    if (this.code[this.currentInput] != null && this.code[this.currentInput] !== '') {
                        this.$set(this.code, this.currentInput, null);
                    } else {
                        this.previousInput();
                    }
                }
            },
            enterPressed() {
                const isValid = this.validateOTP();
                if (isValid) {
                    this.$emit('submit', this.code.join(''));
                }
            },
            validateOTP() {
                let isValid = true;
                if (this.code.length < this.count) return false;
                this.code.forEach((val) => {
                    if (val == null || val.trim() === '') {
                        isValid = false;
                        return false;
                    }
                });
                return isValid;
            },
            autofocus() {
                this.$refs['input_' + this.currentInput][0].focus();
            },
            clearOtp() {
                if (this.code.length === 6) {
                    this.code = [];
                    this.$refs['input_0'][0].focus();
                    this.currentInput = 0;
                }
            }
        },
        mounted() {
            setTimeout(() => {
                this.autofocus();
            }, 100);
        }
    }
</script>

<style>
    .otp-center-text input {
        text-align: center !important;
    }

    .remove-blinking input {
        caret-color: transparent !important;
    }
</style>